import React from 'react';
import classNames from 'classnames';
import { Bubble } from 'tea-component';
import defaultAvatar from '@intelligence/assets/svg/tipicon/kol-default.svg';
import { getAuthorDisplayName } from '@intelligence/components/ReportCard/authors';
import { useOverflowTip } from '../../hooks/useOverflowTip';
import type { IReportAuthorViewModel } from '@intelligence/components/ReportCard/authors';

import './index.scss';

interface IReportAuthorPreviewProps {
  authors: IReportAuthorViewModel[];
  lang: number;
  className?: string;
}

const ReportAuthorPreview: React.FC<IReportAuthorPreviewProps> = ({
  authors,
  lang,
  className = '',
}) => {
  const displayNames = authors
    .map((author) => getAuthorDisplayName(author, lang))
    .filter(Boolean)
    .join(', ');
  const { tip: namesTip, handleMouseEnter: handleNamesMouseEnter } =
    useOverflowTip(displayNames);
  if (authors.length === 0) return null;
  return (
    <div
      className={classNames(
        'dbi-report-author-preview',
        {
          'dbi-report-author-preview--compact': authors.length >= 3,
        },
        className,
      )}
    >
      <div className="dbi-report-author-preview__avatars">
        {authors.map((author) => (
          <img
            key={author.key}
            data-testid="report-author-avatar"
            className={`dbi-report-author-preview__avatar${
              author.isDatasourceAvatar
                ? ' dbi-report-author-preview__avatar--datasource'
                : ''
            }`}
            src={author.avatar || defaultAvatar}
            alt=""
            loading="lazy"
          />
        ))}
      </div>
      <Bubble content={namesTip}>
        <span
          className="dbi-report-author-preview__names"
          onMouseEnter={handleNamesMouseEnter}
        >
          {displayNames}
        </span>
      </Bubble>
    </div>
  );
};

export default React.memo(ReportAuthorPreview);
